module.exports = __webpack_public_path__ + "img/activity_32.c8636c43.png";